import React, { createContext, useContext, useState } from 'react';
import { useGetAllHotelImageTags } from '../queries';
import { ImageTagResponseDto } from '@bandido/shared/dtos';

interface ImageTagsContextValue {
  imageTags: ImageTagResponseDto[];
  openModal: () => void;
  closeModal: () => void;
  isModalOpen: boolean;
}

const ImageTagsContext = createContext<ImageTagsContextValue | undefined>(undefined);

interface ImageTagsProviderProps {
  children: JSX.Element;
}

export function ImageTagsProvider({ children }: ImageTagsProviderProps) {
  const [isModalOpen, setModalOpen] = useState(false);
  const { data } = useGetAllHotelImageTags({
    pageSize: 1000,
    currentPage: 1,
    search: '',
  });

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return React.createElement(
    ImageTagsContext.Provider,
    {
      value: {
        imageTags: data?.items || [],
        openModal,
        closeModal,
        isModalOpen,
      },
    },
    children,
  );
}

export const useImageTags = (): ImageTagsContextValue => {
  const context = useContext(ImageTagsContext);
  if (!context) {
    throw new Error('useSuppliersContext must be used within a SupplierProvider');
  }
  return context;
};
